import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/chainedgenius'
      className='link footer__link'
    >
      Created By ChainedGenius
    </a>
  </footer>
)

export default Footer
